"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _HomeOutlined = _interopRequireDefault(require("@material-ui/icons/HomeOutlined"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _NavigateNext = _interopRequireDefault(require("@material-ui/icons/NavigateNext"));

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactHtmlParser = _interopRequireDefault(require("react-html-parser"));

var _Page = _interopRequireDefault(require("@sprinx/react-mui-layout/Page"));

var _PageBreadcrumbsItem = _interopRequireDefault(require("../../components/PageBreadcrumbsItem"));

var _AppSettingsProvider = require("../../app/AppSettingsProvider/AppSettingsProvider");

var _HtmlHead = _interopRequireDefault(require("../../components/HtmlHead"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(2)
    },
    link: {
      cursor: 'pointer'
    },
    paragraph: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      '& h3': {
        margin: '0'
      }
    },
    flexContainerColumn: {
      alignItems: 'flex-start'
    }
  };
}, {
  name: 'NewsDetailPageLayout'
});

var _ref2 = /*#__PURE__*/_react.default.createElement(_NavigateNext.default, null);

function NewsDetailPageLayout(_ref) {
  var article = _ref.article,
      pClasses = _ref.classes,
      className = _ref.className;
  var classes = useStyles({
    classes: pClasses
  });
  var locale = (0, _AppSettingsProvider.useAppSettingsLocale)();
  var routeUrl = (0, _AppSettingsProvider.useAppSettingsRouteUrl)();
  var body = article.body,
      href = article.href,
      title = article.title;
  var pageHref = routeUrl('newsDetail', {
    locale: locale,
    params: {
      href: href
    }
  });
  var t = (0, _useTranslate.default)();
  return /*#__PURE__*/_react.default.createElement(_Page.default, {
    className: (0, _clsx.default)(classes.root, className),
    classes: {
      content: classes.flexContainerColumn
    },
    BreadcrumbsProps: {
      separator: _ref2,
      disableHistory: true,
      disableHome: true
    },
    breadcrumbItems: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_PageBreadcrumbsItem.default, {
      Icon: _HomeOutlined.default,
      label: t('globalNavigation/home'),
      to: '/'
    }), /*#__PURE__*/_react.default.createElement(_PageBreadcrumbsItem.default, {
      label: t('globalNavigation/articles'),
      to: '/news'
    }), title && /*#__PURE__*/_react.default.createElement(_PageBreadcrumbsItem.default, {
      label: title,
      to: pageHref
    }))
  }, article.htmlHead && /*#__PURE__*/_react.default.createElement(_HtmlHead.default, {
    htmlHead: article.htmlHead
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h1"
  }, title), /*#__PURE__*/_react.default.createElement("div", null, (0, _reactHtmlParser.default)(body)));
}

process.env.NODE_ENV !== "production" ? NewsDetailPageLayout.propTypes = {
  article: _propTypes.default.shape({
    body: _propTypes.default.string,
    href: _propTypes.default.string,
    htmlHead: _propTypes.default.shape({
      meta: _propTypes.default.arrayOf(_propTypes.default.shape({
        content: _propTypes.default.string,
        name: _propTypes.default.string.isRequired
      })),
      title: _propTypes.default.string
    }),
    title: _propTypes.default.string
  }),
  classes: _propTypes.default.shape({
    flexContainerColumn: _propTypes.default.string,
    link: _propTypes.default.string,
    paragraph: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string
} : void 0;
NewsDetailPageLayout.defaultProps = {
  classes: undefined,
  className: undefined
};
var _default = NewsDetailPageLayout;
exports.default = _default;